<app-table-documents
  *ngIf="entite$ | async as entite"
  [source$]="documents$"
  (add)="onAdd($event, entite)"
  (delete)="onDelete($event, entite)"
></app-table-documents>
